import { useState } from "react";
import plusIcon from "assets/icons/faq/plus.svg";
import minusIcon from "assets/icons/faq/minus.svg";
import "./index.scss";

export const SingleFaqQuestion = ({ questionTitle, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const iconImage = isOpen ? minusIcon : plusIcon;
  return (
    <li
      className="single-question-item"
      onClick={() => {
        setIsOpen((currentValue) => !currentValue);
      }}
    >
      <button className="single-question">
        {questionTitle}
        <span className="icon-label">
          <img src={iconImage} alt="Toggle FAQ item" />
        </span>
      </button>
      {isOpen && <div className="faq-answer">{children}</div>}
    </li>
  );
};
